import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  optionStatuses,
  CurrencyType,
  
} from "../../redux/actions/constants";
import { CgnIbanControl } from "../toolbox/CgnIbanControl";
import { withRouter } from "react-router-dom";

class BankAddUpdate extends Component {
  state = {
    pageTitle: "Banka Ekle",
    pageTitleAdd: "Banka Ekle",
    pageTitleUpdate: "Banka Güncelle",
    pageAddLink: "banka-ekle",
    pageListLink: "banka-listele",
    breadcrumb: [{ text: "Banka", link: "#" }],
    isLoading: false,
    urlSplit: [],
    name: "",
    branchCode: "",
    branchName: "",
    accountNo: "",
    iban: "",
    openingBalance: "",
    currencyType: "",
    guid: "",
    status: true,
    nameError: "",
    branchCodeError: "",
    swiftCode: "",
    branchNameError: "",
    accountNoError: "",
    ibanError: "",
    openingBalanceError: "",
    currencyTypeError: "",
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (urlSplit.length === 3 && urlSplit[1] === "banka-guncelle") {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
        isLoading: true,
      });
      this.getById(urlSplit[2]);
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/banks/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              name: response.data.name,
              branchCode: response.data.branchCode,
              branchName: response.data.branchName,
              accountNo: response.data.accountNo,
              iban: response.data.iban,
              openingBalance: response.data.openingBalance,
              currencyType: response.data.currencyType,
              swiftCode: response.data.swiftCode,
              status: response.data.status,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        urlSplit: urlSplit,
        pageTitle: this.state.pageTitleAdd,
        name: "",
        branchCode: "",
        branchName: "",
        accountNo: "",
        swiftCode: "",
        iban: "",
        openingBalance: "",
        currencyType: "",
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      nameError: "",
      branchCodeError: "",
      branchNameError: "",
      accountNoError: "",
      ibanError: "",
      openingBalanceError: "",
      currencyTypeError: "",
      alertErrorMessage: "",
    });
    if (name === "name" && value === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "branchCode" && value === "") {
      this.setState({
        branchCodeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "branchName" && value === "") {
      this.setState({
        branchNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "accountNo" && value === "") {
      this.setState({
        accountNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "iban" && value === "") {
      this.setState({
        ibanError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    // if (name === "iban" && value !== "" && !CgnIbanControl.test(value)) {
    //   this.setState({
    //     ibanError: CgnMessage.ibanErrorMessage,
    //     alertErrorMessage: CgnMessage.alertErrorMessage,
    //   });
    // }
    if (name === "openingBalance" && value === "") {
      this.setState({
        openingBalanceError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "currencyType" && value === "") {
      this.setState({
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };
  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      name: "",
      branchCode: "",
      branchName: "",
      accountNo: "",
      iban: "",
      openingBalance: "",
      currencyType: "",
      swiftCode: "",
      status: true,

      alertErrorMessage: CgnMessage.alertErrorMessage,
      nameError: CgnMessage.textErrorMessage,
      branchCodeError: CgnMessage.textErrorMessage,
      branchNameError: CgnMessage.textErrorMessage,
      accountNoError: CgnMessage.textErrorMessage,
      ibanError: CgnMessage.textErrorMessage,
      openingBalanceError: CgnMessage.textErrorMessage,
      currencyTypeError: CgnMessage.textErrorMessage,
    });
  }

  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }

  handleCurrencyTypeSelectChange(option) {
    if (option) {
      this.setState({
        currencyType: option.value,
        currencyTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        currencyType: "",
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      alertErrorMessage: "",
      nameError: "",
      branchCodeError: "",
      branchNameError: "",
      accountNoError: "",
      ibanError: "",
      openingBalanceError: "",
      currencyTypeError: "",
    });
    if (this.state.name === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.branchCode === "") {
      this.setState({
        branchCodeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.branchName === "") {
      this.setState({
        branchNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.accountNo === "") {
      this.setState({
        accountNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.iban === "") {
      this.setState({
        ibanError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    // if (this.state.iban !== "" && !CgnIbanControl.test(this.state.iban)) {
    //   this.setState({
    //     ibanError: CgnMessage.ibanErrorMessage,
    //     alertErrorMessage: CgnMessage.alertErrorMessage,
    //   });
    // }
    if (this.state.openingBalance === "") {
      this.setState({
        openingBalanceError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.currencyType === "") {
      this.setState({
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (
      this.state.name !== "" &&
      this.state.branchCode !== "" &&
      this.state.branchName !== "" &&
      this.state.accountNo !== "" &&
      this.state.iban !== "" &&
      CgnIbanControl.test(this.state.iban) &&
      this.state.openingBalance !== "" &&
      this.state.currencyType
    ) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        name: this.state.name,
        branchCode: this.state.branchCode,
        branchName: this.state.branchName,
        accountNo: this.state.accountNo,
        swiftCode: this.state.swiftCode,
        iban: this.state.iban,
        openingBalance: parseFloat(this.state.openingBalance),
        currencyType: this.state.currencyType,
        status: this.state.status,
      };
      var URLParam = "/banks/add";
      if (this.state.guid && this.state.urlSplit.length !== 2) {
        URLParam = "/banks/update";
        myObj = {
          guid: this.state.guid,
          name: this.state.name,
          branchCode: this.state.branchCode,
          branchName: this.state.branchName,
          accountNo: this.state.accountNo,
          swiftCode: this.state.swiftCode,
          iban: this.state.iban,
          openingBalance: parseFloat(this.state.openingBalance),
          currencyType: this.state.currencyType,
          status: this.state.status,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (this.state.guid) {
              window.location.href = "/banka-listele";
            }
            if (this.state.urlSplit[1] === "banka-ekle") {
              window.location.reload();
            }
            var modalAddedBank = {
              data: this.state.name,
              isModal: false,
            };
            this.props.history.push({ modalAddedBank });
            this.setState({
              isLoading: false,
            });
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "banka-ekle" ||
          this.state.urlSplit[1] === "banka-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="name"
                      label="Banka Adı [*]"
                      value={this.state.name}
                      placeHolder="Lütfen banka adı girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.nameError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="branchCode"
                      label="Şube Kodu [*]"
                      value={this.state.branchCode}
                      placeHolder="Lütfen şube kodu girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.branchCodeError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="branchName"
                      label="Şube Adı [*]"
                      value={this.state.branchName}
                      placeHolder="Lütfen şube adı girin..."
                      maxLength="50"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.branchNameError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="swiftCode"
                      label="Swift Kodu"
                      value={this.state.swiftCode}
                      placeHolder="Lütfen swift kodu girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      //error={this.state.accountNoError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="number"
                      name="accountNo"
                      label="Hesap No [*]"
                      value={this.state.accountNo}
                      placeHolder="Lütfen hesap no girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.accountNoError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="iban"
                      label="IBAN [*]"
                      value={this.state.iban}
                      placeHolder="Lütfen IBAN girin..."
                      maxLength="50"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.ibanError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="number"
                      name="openingBalance"
                      label="Açılış Bakiye [*]"
                      value={this.state.openingBalance}
                      placeHolder="Lütfen açılış bakiyesi girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.openingBalanceError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnReactSelect
                      name="currencyType"
                      label="Para Birimi [*]"
                      placeholder="Lütfen para birimi seçiniz..."
                      selectValue={this.state.currencyType}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCurrencyTypeSelectChange(option)
                      }
                      options={CurrencyType}
                      error={this.state.currencyTypeError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.status}
                      options={optionStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                    />
                  </Col>
                </Row>

                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>

            {(this.state.urlSplit[1] === "banka-ekle" ||
              this.state.urlSplit[1] === "banka-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(BankAddUpdate);
